import { apiClient } from "./ApiClient";

export interface Transaction {
  id: number;
  asset_id: number;
  name: string;
  category: string;
  amount: number;
  payee?: string;
  transaction_type: "INCOME" | "EXPENSE";
  date: string;
  is_pending: boolean;
  duplicate: "T" | "F";
  created_by: string;
  unit?: number | null;
  created_at: string;
  updated_at: string;
}

export interface CreateTransactionDto {
  name: string;
  category: string;
  amount: number;
  date: string;
  transaction_type: "INCOME" | "EXPENSE";
  unit?: number | null;
}

export interface CreateBulkTransactionDto {
  name: string;
  category: string;
  amount: number;
  payee?: string;
  transaction_type: "INCOME" | "EXPENSE";
  importType: "single" | "ytd" | "month_range" | "custom_range";
  startDate?: string;
  endDate?: string;
  frequency?: "monthly" | "quarterly" | "half_yearly" | "annually";
  singleDate?: string;
  unit?: number | null;
}

export interface UpdateTransactionDto {
  name: string;
  category: string;
  amount: number;
  date: string;
  transaction_type: "INCOME" | "EXPENSE";
  unit?: number | null;
}

export interface BulkTransactionResponse {
  message: string;
  count: number;
  transactions: Transaction[];
}

class TransactionService {
  async getAssetTransactions(assetId: string | number): Promise<Transaction[]> {
    const { data } = await apiClient.get(`/assets/${assetId}/transactions`);
    return data;
  }

  async createTransaction(
    assetId: string | number,
    transaction: CreateTransactionDto
  ): Promise<Transaction> {
    const { data } = await apiClient.post(
      `/assets/${assetId}/transactions`,
      transaction
    );
    return data;
  }

  async createBulkTransactions(
    assetId: string | number,
    bulkTransaction: CreateBulkTransactionDto
  ): Promise<BulkTransactionResponse> {
    const { data } = await apiClient.post(
      `/assets/${assetId}/transactions/bulk`,
      bulkTransaction
    );
    return data;
  }

  async updateTransaction(
    assetId: string | number,
    transactionId: number,
    transaction: UpdateTransactionDto
  ): Promise<Transaction> {
    const { data } = await apiClient.put(
      `/assets/${assetId}/transactions/${transactionId}`,
      transaction
    );
    return data;
  }

  async deleteTransaction(
    assetId: string | number,
    transactionId: number
  ): Promise<void> {
    await apiClient.delete(`/assets/${assetId}/transactions/${transactionId}`);
  }
}

export default new TransactionService();
